import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { changeDeliveryMethod, changeUserLastName, changeUserName, changeUserPhoneNumber } from '../../../graph-ql/mutations';
import { usersByRolForCalendarQuery, usersByRolQuery, usersQuery } from '../../../graph-ql/queries';
import { changeSignMail } from '../../../graph-ql/user/user.mutation';
import { getSignMail, getUsersConfigurationCompany } from '../../../graph-ql/user/user.queries';
import { PaginationInput } from '../../models/common/paginationInput';
import { UserFilter } from '../../models/lead/userFilter';
import { UserInput } from '../../models/lead/userInput';
import { User } from '../../models/user/user.model';
import { UserResponse } from '../../models/user/user.response';
import { UserConfiguration } from '../../models/user/userConfiguration.response';

@Injectable()
export class UserService {

  constructor(public apollo: Apollo) {
  }

  usersQuery$(page: number, itemPerPage: number): Observable<UserResponse> {
    return this.apollo.query<UserResponse>({
      query: usersQuery,
      variables: {
        userInput: {
          paginationInput: {
            page,
            itemPerPage
          }
        }
      }
    })
      .pipe(map(result =>
        new UserResponse(result.data['getUsers']['users'], result.data['getUsers']['totalCount']
        )));
  }

  changeUserName$(newName: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changeUserName,
        variables: {
          input: newName
        }
      });
  }

  changeUserLastName$(newLastNameInput: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changeUserLastName,
        variables: {
          input: newLastNameInput
        }
      });
  }
  changeUserPhoneNumber$(newPhoneNumberInput: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changeUserPhoneNumber,
        variables: {
          input: newPhoneNumberInput
        }
      });
  }
  changeDeliveryMethod$(newDeliveryMethod: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changeDeliveryMethod,
        variables: {
          input: newDeliveryMethod
        }
      });
  }

  usersByRolQuery$(paginationInput?: PaginationInput, userFilter?: UserFilter, isPlanDay?: boolean): Observable<UserResponse> {
    return this.apollo.query<UserResponse>({
      query: usersByRolQuery,
      variables: {
        userInput: new UserInput(paginationInput, userFilter, isPlanDay)
      }
    })
      .pipe(map(result => {
        if (!result.data['getUsersByRol']) {
          return new UserResponse([], 0);
        }
        const lista: User[] = result.data['getUsersByRol']['users'];

        return new UserResponse(lista, result.data['getUsersByRol']['totalCount']
        );
      }));
  }

  usersByRolForCalendarQuery$(paginationInput?: PaginationInput, userFilter?: UserFilter, isPlanDay?: boolean): Observable<UserResponse> {
    return this.apollo.query<UserResponse>({
      query: usersByRolForCalendarQuery,
      variables: {
        userInput: new UserInput(paginationInput, userFilter, isPlanDay)
      }
    })
      .pipe(map(result => {
        if (!result.data['getUsersByRolForCalendars']) {
          return new UserResponse([], 0);
        }
        const lista: User[] = result.data['getUsersByRolForCalendars']['users'];

        return new UserResponse(lista, result.data['getUsersByRolForCalendars']['totalCount']
        );
      }));
  }

  changeSignMail$(newSignMail: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changeSignMail,
        variables: {
          input: newSignMail
        }
      });
  }

  getUserConfiguration$() {
    return this.apollo
      .query(
        {
          query: getUsersConfigurationCompany
        }
      )
      .pipe(map(result => {
        return new UserConfiguration(result.data['getUsersConfigurationCompany']);
      }));
  }
  getSignMail$() {
    return this.apollo
      .query(
        {
          query: getSignMail
        }
      )
      .pipe(map(result => {
        return result.data['getUsersConfigurationCompany'].signMail;
      }));
  }
}
